import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCurrentCountry } from '@/utils/domain';
import { shouldHideSender } from '@/utils/hideSender';
import SendUsingFile from './SendUsingFile';
import SenderContainer from './Sender';
import SmsTemplateContainer from './SmsTemplate';
import QuickSend from './QuickSend';

function SmsContainer() {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const { t } = useTranslation();

  // to get the current country
  const country = getCurrentCountry();

  const [activeTab, setActiveTab] = useState();
  const items = [
    {
      label: t('sms_page.tabs.first'),
      key: '#quick-send',
      children: <QuickSend />,
    },
    {
      label: t('sms_page.tabs.second'),
      key: '#send-using-file',
      children: <SendUsingFile />,
    },
    ...(shouldHideSender(country)
      ? []
      : [
          {
            label: t('sms_page.tabs.third'),
            key: '#sender-name',
            children: <SenderContainer />,
          },
        ]),
    {
      label: t('sms_page.tabs.fourth'),
      key: '#template',
      children: <SmsTemplateContainer />,
    },
  ];

  useEffect(() => {
    setActiveTab(hash || '#quick-send');
  }, [hash]);

  const handleOnClickChangeTab = (key) => {
    setActiveTab(key);
    navigate(`${window.location.pathname}${key}`);
  };

  return (
    <div className="sms-container">
      <Tabs
        items={items}
        activeKey={activeTab}
        onTabClick={handleOnClickChangeTab}
        destroyInactiveTabPane
      />
    </div>
  );
}

export default SmsContainer;
